export enum LinkedAccountStatusEnum {
    New = 1,
    Active = 2,
    Inactive = 3
}
